<template>
  <div class="full-width">
    <div>
      <input
          id="custom-color"
          class="color-picker"
          :class="{ 'color-site-selected': !selectedColor }"
        v-model="selectedColor"
        type="color"
    ></div>
    <div
        :style="{ backgroundColor: selectedColor}"
        class="d-flex justify-content-center align-items-center"
    >
     <span class="text-white text-bold">{{ selectedColor }}</span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    selectedColor: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped>
div {
  height: 50px;
  margin: 5px;
  cursor: pointer;
}

.color-picker {
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
}

.color-picker input[type="color"] {
  height: 100%;
  padding: 0;
  border: none;
  border-radius: 4px;
}
</style>
